import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  logoutSuccess,
  removeAppSettings,
  stopRefreshInterval,
} from "../store/actions";
import API from "../api";
import { API_LOGOUT } from "../constants/api";
import { errorStatusHandle } from "../utils/error-utils";
import { SIGN_IN } from "../constants/routes";
import { useNavigate } from "react-router-dom";

function Logout() {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      var authState = localStorage.getItem("auth");
      var authItem = JSON.parse(authState);
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Beer ${authItem.refresh_token}`,
      };
      try {
        const response = await API.post(API_LOGOUT, {}, { headers });
        dispatch(stopRefreshInterval());
        dispatch(logoutSuccess());
        dispatch(removeAppSettings());
        return navigate(SIGN_IN);
      } catch (e) {
        errorStatusHandle(e.response);
      }
    };
    handleLogout();
  });
}

export default Logout;
